import { Component } from '@angular/core';
import { SidebarNavMenuItem } from '../../decorators/sidebar-nav-menu-item';

@SidebarNavMenuItem({
  route: 'support',
  faIcon: 'help_outline',
  name: 'Support',
  order: 9500
})
@Component({
  selector: 'app-support',
  template: `<h1>this is support v1</h1>`,
  styleUrl: './support.component.css'
})
export class SupportComponent {

}

